import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import BranchesSection from "./BranchesSection";
import FacilitiesSection from "./FacilitiesSection";
import PlatformUsageSection from "./PlatformUsageSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    let timer;
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0; // Get header height

    console.log('Location hash:', location.hash);
    console.log('Header height:', headerHeight);

    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);

      console.log('Target ID:', id);
      console.log('Target element:', el);

      if (el) {
        timer = setTimeout(() => {
          const targetScrollTop = el.offsetTop - headerHeight;
          console.log('Element offsetTop:', el.offsetTop);
          console.log('Calculated scroll top:', targetScrollTop);
          window.scrollTo({
            top: targetScrollTop,
            behavior: "smooth",
          });
        }, 500); // Increased delay to ensure all content is rendered
      } else {
        console.log(`Element with ID '${id}' not found. Scrolling to top.`);
        window.scrollTo(0, 0);
      }
    } else {
      console.log('No hash in URL. Scrolling to top.');
      window.scrollTo(0, 0);
    }
    return () => clearTimeout(timer);
  }, [location.hash, location.key]);
  return (
    <div className="min-h-screen aptos-override">
      <Header />
      <HeroSection id="home" />
      <AboutSection id="about" />
      <BranchesSection id="branches" />
      <FacilitiesSection id="facilities" />
      <PlatformUsageSection id="platform-usage" />
      <ContactSection id="contact" />
      <Footer />
    </div>
  );
};

export default LandingPage;
